import {
  TableCellType,
  TableHeader,
} from "../../../../components/custom-table/table";
import { authStatusForDisablingTriggerRpa } from "../../../../constants/authStatusForDisablingTriggerRpa";
import {
  getDocumentsUploadStatusForStatus,
  statusToDocumentUploadMap,
} from "../../../../constants/statusToDocMap/docUploadMap";
import { getDocumentsForStatus } from "../../../../constants/statusToDocMap/statusToDocMap";
import {
  JCodeDetails,
  MedicalPaOrder,
} from "../../../../data-model/medicalPaOrdersModel";
import { DocumentType } from "../../../../enums/documentTypes";
import { DocWriteBackStatus } from "../../../../enums/evBvWriteBackStatus";
import { CptCodeWithDetailsKeys } from "../../../../enums/tableColumnKeys";
import { setItemInLocalStorage } from "../../../../utils/localStorageHelper";
import {
  checkifAllDocsAreUploaded,
  getDocsNotBelongingToCurrentAuthStatus,
} from "./utils/getDocsFromStatus";

export const CptCodesTableColumnsKeys: TableHeader[] = [
  {
    label: "J Codes",
    key: CptCodeWithDetailsKeys.JCodes,
    order: 1,
    width: 15,
    type: TableCellType.STRING,
  },
  {
    label: "",
    key: CptCodeWithDetailsKeys.Documents,
    order: 2,
    width: 80,
    type: TableCellType.STRING_WITH_BUTTON,
  },
  {
    label: "",
    key: CptCodeWithDetailsKeys.DocWithUploadIcon,
    order: 3,
    width: 5,
    type: TableCellType.DOC_WITH_UPLOAD_ICON,
  },
];

export const generateCptCodesTableData = (data: MedicalPaOrder) => {
  const authEntries = data?.auth_on_file?.auth_entries ?? [];
  const getAllJCodesData = () => {
    let JcodesData: JCodeDetails[] = [];
    authEntries.forEach((item) => {
      JcodesData.push(...(item?.j_codes ?? []));
    });
    return JcodesData;
  };
  const JcodesData = getAllJCodesData();

  const allMedicineNames: string[] = [];
  JcodesData.forEach((item) => {
    if (item?.medicine_name && Array.isArray(item.medicine_name)) {
      allMedicineNames.push(...item.medicine_name);
    }
  });

  setItemInLocalStorage("medicineNames", allMedicineNames);
  const allKeys = Object.keys(statusToDocumentUploadMap);

  return JcodesData.map((item) => {
    const description = () => {
      if (item?.description && item?.description !== "") {
        return item?.description;
      }
      return item?.medicine_name?.join(", ") ?? "N/A";
    };

    const globalAuthStatus = data?.auth_on_file?.auth_status || "not_available";

    const authStatus = item?.auth_status || "not_available";

    const allDocsAreUploaded = checkifAllDocsAreUploaded(
      authStatus,
      item?.documents ?? [],
      item?.id ?? "",
      item?.j_code ?? "",
    );

    const docsNotBelongingToCurrentAuthStatus =
      getDocsNotBelongingToCurrentAuthStatus(
        authStatus,
        item?.documents ?? [],
        item?.j_code ?? "",
        item?.id ?? "",
      );

    return {
      [CptCodeWithDetailsKeys.JCodes]: item?.j_code + " - " + description(),
      [CptCodeWithDetailsKeys.JCodeID]: item?.id ?? "N/A",
      [CptCodeWithDetailsKeys.Documents]: {
        authStatus,
        docs: authStatusForDisablingTriggerRpa.includes(globalAuthStatus)
          ? []
          : [...docsNotBelongingToCurrentAuthStatus, ...allDocsAreUploaded],
        doc_upload_status:
          data?.status?.document_upload_status ??
          DocWriteBackStatus.NOT_INITIATED,
        patient_id: data?.payload?.patient_id ?? "",
        order_id: data?.id ?? "",
        shouldLogEvent: true,
      },
      [CptCodeWithDetailsKeys.DocWithUploadIcon]: {
        status:
          data?.status?.document_upload_status ??
          DocWriteBackStatus.NOT_INITIATED,
        shouldHideUploadIcon:
          !allKeys.includes(authStatus) ||
          authStatusForDisablingTriggerRpa.includes(globalAuthStatus),
      },
    };
  });
};

export const getDocumentTypesForAuthStatus = (authStatusId: string) => {
  return getDocumentsForStatus(authStatusId);
};

export const getDocumentUploadStatusForAuthStatus = (authStatusId: string) => {
  return getDocumentsUploadStatusForStatus(authStatusId);
};

export const getDocumentTypeDisplayName = (documentType: string) => {
  switch (documentType) {
    case DocumentType.FILLED_FORM:
      return "Upload filled form";
    case DocumentType.APPROVAL_LETTER:
      return "Upload approval letter";
    case DocumentType.DENIAL_LETTER:
      return "Upload Denial Letter";
    case DocumentType.NAR_LETTER:
      return "NAR Letter";
    default:
      return "Upload Required Document";
  }
};
